import { ax } from './config'

export class BaseService {
  url

  constructor(url) {
    this.url = url
  }

  /**
   *
   * @param {Object} payload payload
   * @returns data
   */
  async login(payload) {
    const data = await ax.post(this.url, payload, {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
        Accept: 'Application/json',
      },
    })
    return data.data
  }

  async register(payload) {
    const res = ax.post(this.url, payload, {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
        Accept: 'Application/json',
      },
    })
    return res
  }

  /** @typedef {object} params
   * @param {String[]} user ["STAFF","LEADER"]
   */

  async getModules(params) {
    const user = params.user
    var p = ''
    user.forEach((elm) => {
      p += params.user[user.length - 1] === elm ? `"${elm}"` : `"${elm}"%2C`
    })
    delete params.user
    const res = await ax.get(`${this.url}?user=%5B${p}%5D`, {
      params: {
        ...params,
      },
    })
    return res.data
  }

  async getModulesV2(params) {
    const res = await ax.post(`${this.url}`, new URLSearchParams(params))
    return res.data
  }

  /**
   * @param {String} id id module
   * @returns {Object} promises object
   */
  async getRules(params) {
    const res = ax.get(this.url, {
      params: {
        ...params,
      },
    })
    return res
  }

  /**
   * @param {String} payload id_module
   * @returns promises object
   */
  async getQuestion(params) {
    const res = ax.get(this.url, {
      params: {
        ...params,
      },
    })
    return res
  }

  async postAnswer(payload) {
    const res = ax.post(this.url, payload, {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
        Accept: '*/*',
      },
    })
    return res
  }

  async postResultPapiKostikPng(payload) {
    const res = ax.post(this.url, payload, {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
        Accept: '*/*',
      },
    })
    return res
  }

  /**
   * @param {String} user_id id user
   * @returns {Object} promises object
   */
  async getHistory(params) {
    const res = ax.get(this.url, {
      params: {
        ...params,
      },
    })
    return res
  }

  async getPosition(params) {
    const res = ax.get(this.url, {
      params: {
        ...params,
      },
    })
    return res
  }

  async postPictureCaptured(payload) {
    const formData = new URLSearchParams()
    for (const key in payload) {
      if (payload[key] !== null && payload[key] !== undefined) {
        formData.append(key, payload[key])
      }
    }

    const res = ax.post(this.url, formData, {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
        Accept: '*/*',
      },
    })
    return res
  }

  async postUserLog(payload) {
    const res = ax.post(this.url, payload, {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
        Accept: '*/*',
      },
    })
    return res
  }

  async getDob(params) {
    const res = await ax.get(this.url, {
      params: {
        ...params,
      },
    })
    return res.data
  }

  async updateDob(params) {
    const res = await ax.get(this.url, {
      params: {
        ...params,
      },
    })
    return res.data
  }
}
